export const CodeBookFragment = gql`
  fragment CodeBookFragment on CodeBook {
    id
    importError
    importStartedAt
    importStatus
    name
    items {
      ...CodeBookItemFragment
    }
  }
`
